// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /*Blue Button components colors*/
    --BlueButtonComponentBackground: var(--DarkBlue);
    --BlueButtonComponentBorderColor: var(--HighlightBlue);
    --BlueButtonComponentTextColor: var(--HighlightBlue);
    --BlueButtonComponentBorderRadius: 10px;

    /* Blue Button small compontents */
    --BlueButtonSmallBackground: var(--HighlightBlue);
    --BlueButtonSmallActive: var(--GrayBlue);

    /* Dark Blue Button*/
    --DarkBlueButtonBackground: var(--Gray);
    --DarkBlueButtonActive: var(--GrayBlue);

    /*InputBarBlue && InputBarBlue small*/
    --InputBarBlueBorderColor: var(--DarkBlue);
    --InputBarBlueBackground: var(--GrayBlue);
    --InputBarBlueOnFocus: var(--Gray);
    --InputBarBlueOnError: var(--Gray);
    --InputBarBlueOnSucces: var(--HighlightBlue);

    /*PriceSelector*/
    --PriceSelectorBorder: var(--DarkBlue);
    --PriceSelectorBackground: var(--GrayBlue);
    --PriceSelectorSelectColor: var(--topbarSelectorColor);
    --PriceSelectorOptionsBackground: var(--DarkBlue);

    /*InputContainer*/
    --InputContainerBackground: var(--DarkBlue);
    --InputContainerMessageColor: var(--Gray);
    --InputContainerContainerBackground: var(--Gray);

    /*Container*/
    --ContainerBorderColor: var(--DarkBlue);
    --ContainerBackgroung: var(--DarkBlue);
    --ContainerTitleTextDisplay: var(--LiterGrayBlue);
    --ContainerHeadLineColor: var(--GrayBlue);
    --ContainerInContainerBorder: var(--Gray);
    --ContainerInContainerBackground: var(--Gray);
}
`, "",{"version":3,"sources":["webpack://./src/style/components.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,gDAAgD;IAChD,sDAAsD;IACtD,oDAAoD;IACpD,uCAAuC;;IAEvC,kCAAkC;IAClC,iDAAiD;IACjD,wCAAwC;;IAExC,oBAAoB;IACpB,uCAAuC;IACvC,uCAAuC;;IAEvC,qCAAqC;IACrC,0CAA0C;IAC1C,yCAAyC;IACzC,kCAAkC;IAClC,kCAAkC;IAClC,4CAA4C;;IAE5C,gBAAgB;IAChB,sCAAsC;IACtC,0CAA0C;IAC1C,sDAAsD;IACtD,iDAAiD;;IAEjD,iBAAiB;IACjB,2CAA2C;IAC3C,yCAAyC;IACzC,gDAAgD;;IAEhD,YAAY;IACZ,uCAAuC;IACvC,sCAAsC;IACtC,iDAAiD;IACjD,yCAAyC;IACzC,yCAAyC;IACzC,6CAA6C;AACjD","sourcesContent":[":root {\n    /*Blue Button components colors*/\n    --BlueButtonComponentBackground: var(--DarkBlue);\n    --BlueButtonComponentBorderColor: var(--HighlightBlue);\n    --BlueButtonComponentTextColor: var(--HighlightBlue);\n    --BlueButtonComponentBorderRadius: 10px;\n\n    /* Blue Button small compontents */\n    --BlueButtonSmallBackground: var(--HighlightBlue);\n    --BlueButtonSmallActive: var(--GrayBlue);\n\n    /* Dark Blue Button*/\n    --DarkBlueButtonBackground: var(--Gray);\n    --DarkBlueButtonActive: var(--GrayBlue);\n\n    /*InputBarBlue && InputBarBlue small*/\n    --InputBarBlueBorderColor: var(--DarkBlue);\n    --InputBarBlueBackground: var(--GrayBlue);\n    --InputBarBlueOnFocus: var(--Gray);\n    --InputBarBlueOnError: var(--Gray);\n    --InputBarBlueOnSucces: var(--HighlightBlue);\n\n    /*PriceSelector*/\n    --PriceSelectorBorder: var(--DarkBlue);\n    --PriceSelectorBackground: var(--GrayBlue);\n    --PriceSelectorSelectColor: var(--topbarSelectorColor);\n    --PriceSelectorOptionsBackground: var(--DarkBlue);\n\n    /*InputContainer*/\n    --InputContainerBackground: var(--DarkBlue);\n    --InputContainerMessageColor: var(--Gray);\n    --InputContainerContainerBackground: var(--Gray);\n\n    /*Container*/\n    --ContainerBorderColor: var(--DarkBlue);\n    --ContainerBackgroung: var(--DarkBlue);\n    --ContainerTitleTextDisplay: var(--LiterGrayBlue);\n    --ContainerHeadLineColor: var(--GrayBlue);\n    --ContainerInContainerBorder: var(--Gray);\n    --ContainerInContainerBackground: var(--Gray);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
